import { Component, OnInit, Input,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogTitle} from '@angular/material/dialog';
import { Proceso, Procedimiento } from 'src/app/interfaces/interfaces';
import { DataService } from 'src/app/services/data.service';
import { FormGroup, FormControl} from '@angular/forms';




@Component({
  selector: 'app-modal-costeo-consulta',
  templateUrl: './modal-costeo-consulta.component.html',
  styleUrls: ['./modal-costeo-consulta.component.css']
})
export class ModalCosteoConsultaComponent implements OnInit {
tablaProcedimientos: Procedimiento[]=[];
tablaProcedimientosToBe: Procedimiento[]=[];
tabla: Procedimiento[]=[];
idProceso: string;
idIniciativa:string;
formProcesos: FormGroup;
tabs = ['Procedimiento'];
selectedTabs = new FormControl(0);
tabSeleccionado:number=0;
tabuladores: any[]=[];


  constructor(private dataService: DataService,
    public dialog:MatDialog,@Inject(MAT_DIALOG_DATA) public datos:any) {
   }

  ngOnInit(): void {
    this.idIniciativa=this.datos['id_iniciativa'];
    this.idProceso=this.datos['id_proceso'];
    this.verDetallesProceso(parseInt(this.idIniciativa),0);
    

    this.formProcesos= new FormGroup({
      id_proceso:new FormControl(''),
      id_iniciativa: new FormControl(''),
      nombre_proceso: new FormControl(''),
      procedimiento_proceso: new FormControl(''),
      duenio_proceso: new FormControl(''),
      tramitesExternosASIS_proceso: new FormControl(''),
      tramitesInternosASIS_proceso: new FormControl(''),
      tramitesExternosTOBE_proceso: new FormControl(''),
      tramitesInternosTOBE_proceso: new FormControl(''),
      hojasImpresasASIS_proceso : new FormControl(''),
      hojasImpresasTOBE_proceso : new FormControl(''),
      kmRecorridosASIS_Proceso: new FormControl(''),
      kmRecorridosTOBE_Proceso: new FormControl('')

    })
    
  }


//Método para recuperar los datos del costeo
verDetallesProceso(id_iniciativa:number, id_proceso:number)
{
  this.dataService.detalleProceso(id_iniciativa,id_proceso).subscribe(data => {
    if (data['objData']['proceso']) 
    {
      let infoProceso: Proceso = data['objData']['proceso'];
      this.formProcesos.patchValue({
        id_proceso:infoProceso.id_proceso,
        nombre_proceso:infoProceso.nombre_proceso,
        procedimiento_proceso:infoProceso.procedimiento_proceso,
        duenio_proceso:infoProceso.duenio_proceso,
        tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
        tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
        tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
        tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
        hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
        hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
        kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
        kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
      })
    }
    this.tabla=data['objData']['listDetalleProcesos'];
    //Llenamos los procedimientos
    if(data['objData']['listDetalleProcesos'])
    {
      for(let numero of this.tabla)
      {
        if(numero.tipoProceso_procesoDetalle==1)
        { 
            this.tablaProcedimientosToBe.push(numero);
        }
        else{
          this.tablaProcedimientos.push(numero);
        }
      }

    }
    this.tabuladores=data['objData']['listIdProceso'];
    /*this.tabuladores.forEach((element, index) => {
      this.tabs.push(`Procedimiento ${this.tabs.length + 1}`);
    });*/
    //Generamos los tabuladores necesarios
    for(let numero of this.tabuladores)
    {
      this.tabs.push(`Procedimiento ${this.tabs.length + 1}`); 
    }

    //Eliminamos el ultimo tap cuando la iniciativa trae procesos 
    if(this.tabuladores.length!=0)
    {
      this.removeTab(this.tabs.length-1);
    }
    //Eliminamos el ultmo tap
    //this.removeTab(this.tabs.length-1);
});
}

  //Eliminar tabs
  removeTab(index: number) 
  {
    this.tabs.splice(index, 1);
  }
  
  //Metodo para navegar entre los tabuladores
  navegarTab(form:number)
  {
    this.tabSeleccionado=form;
    //Limpiamos la tabla de procedimientos/arrays
    this.formProcesos.reset();
    this.tabla=[];
    this.tablaProcedimientosToBe=[];
    this.tablaProcedimientos=[];
      this.tabuladores.forEach((element, index) => {
       if(form==index)
       {
        this.dataService.detalleProceso(parseInt(this.idIniciativa),element).subscribe(data => {
          if (data['objData']['proceso']) 
          {
            let infoProceso: Proceso = data['objData']['proceso'];
            this.formProcesos.patchValue({
              id_proceso:infoProceso.id_proceso,
              nombre_proceso:infoProceso.nombre_proceso,
              procedimiento_proceso:infoProceso.procedimiento_proceso,
              duenio_proceso:infoProceso.duenio_proceso,
              tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
              tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
              tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
              tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
              hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
              hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
              kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
              kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
            })
          }
    
          this.tabla=data['objData']['listDetalleProcesos'];
          //Llenamos los procedimientos
          if(data['objData']['listDetalleProcesos'])
          {
            for(let numero of this.tabla)
            {
              if(numero.tipoProceso_procesoDetalle==1)
              { 
                  this.tablaProcedimientosToBe.push(numero);
              }
              else{
                this.tablaProcedimientos.push(numero);
              }
            }
    
          }
           
        });
       }
      
      });
      
  }

}
